import {PurchaseOrderDrafts} from "./PurchaseOrderDrafts";

const ProcurementPODrafts = () => <PurchaseOrderDrafts />;

export default ProcurementPODrafts;
